<template>
    <div style="background:#FFF;">
        <h3 class="title-bar clearfix">
            <!-- 型式试验详情 -->
            <span>{{$t('typeTestProcessSearch.t42')}}</span>
            <!-- 返回 -->
            <Button type='ghost' class='mg-r-10' @click='goBack'>{{$t('commonTw.t3')}}</Button>
            <!-- 提交 -->
            <Button v-if="reportObj.reportStatus === 'WAITING'" type="primary" class='mg-r-10' :loading="loading" @click="reportSubmit('SUBMIT')">{{$t('commonTw.t4')}}</Button>
            <!-- 暂存 -->
            <Button v-if="reportObj.reportStatus === 'WAITING'" type="primary" class='mg-r-10' :loading="loading" @click="reportSubmit('TS')">{{$t('typeTestProcessSearch.t43')}}</Button>
        </h3>
        <div class="container">
            <custom-panel name="1" :gutter="false">
                <!-- 批次信息 -->
                {{$t('typeTestProcessSearch.t44')}}
                <div slot="content">
                    <div class="form-wrap">
                        <Form :label-width="95" :model="reportObj" ref="reportForm" :rules="reportRules">
                            <Row>
                                <Col :span="6">
                                <!-- 事业部 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t4')">
                                        <Input type="text" disabled v-model="reportObj.divName" :title="reportObj.divName"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                <!-- 检验单号 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t45')">
                                        <Input type="text" disabled v-model="reportObj.examinedNo" :title="reportObj.examinedNo"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                <!-- 物料编码 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t11')">
                                        <Input type="text" disabled v-model="reportObj.itemCode" :title="reportObj.itemCode"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                <!-- 物料描述 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t12')">
                                        <Input type="text" disabled v-model="reportObj.itemDesc" :title="reportObj.itemDesc"/>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style="margin-top:10px;">
                                <Col :span="6">
                                <!-- 试验类型 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t8')" prop="testType">
                                        <Select v-model="reportObj.testType"
                                                placeholder="" clearable
                                                :disabled="true"
                                                @on-change="onTestTypeChange">
                                            <Option v-for="(item, index) in dict.testTypeList" :value="item.value" :key="index">{{item.label}}
                                            </Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                <!-- 单据来源 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t46')">
                                        <Input type="text" disabled v-model="reportObj.dataSource" :title="reportObj.dataSource"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                <!-- 发布人 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t47')">
                                        <Input type="text" disabled v-model="reportObj.releaseUser"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                <!-- 发布时间 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t48')">
                                        <Input type="text" disabled v-model="reportObj.releaseDateStr"/>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style="margin-top:10px;">
                                <Col :span="6">
                                <!-- 计划报告上传日期 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t49')">
                                        <Input type="text" disabled v-model="reportObj.reportUploadDateStr"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                <!-- 样本数量 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t50')">
                                        <Input type="text" disabled v-model="reportObj.sampleQty"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                <!-- 驳回原因 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t14')" prop="rejectReason">
                                        <Input type="text" v-model="reportObj.rejectReason" disabled/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                <!-- 驳回次数 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t13')" prop="rejectCount">
                                            <Input type="text" v-model="reportObj.rejectCount" disabled/>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col :span="6">
                                <!-- 检验单有效性 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t51')" prop="stateResult">
                                        <Input type="text" v-model="reportObj.stateResult" disabled/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                <!-- 最后修改时间 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t52')" prop="datetimeModifiedStr">
                                        <Input type="text" v-model="reportObj.datetimeModifiedStr" disabled/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                <!-- 最后修改人 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t53')" prop="lastUpdatedBy">
                                        <Input type="text" v-model="reportObj.lastUpdatedBy" disabled/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                    <!-- GSC在提交的时候，判断如果计量或计数结果有不合格，则不合格，否则合格 -->
                                    <!-- 综合判断结果 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t51')" prop="mainJudgeName">
                                        <Input type="text" v-model="reportObj.mainJudgeName" disabled/>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style="margin-top:10px;">
                                <Col :span="6">
                                <!-- 检验员 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t33')" prop="examinedUser">
                                        <Input type="text" v-model.trim="reportObj.examinedUser" :disabled="btnDisabled"/>
                                    </FormItem>
                                </Col>
                                <Col :span="6">
                                <!-- 生产批次号 -->
                                    <FormItem :label="$t('typeTestProcessSearch.t55')" prop="supplierBatchNumber">
                                        <Input type="text"
                                                v-model.trim="reportObj.supplierBatchNumber"
                                                :readonly="btnDisabled"
                                                :disabled="btnDisabled"/>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row style="margin-top:10px;">
                                <!-- ‘试验类型’是‘型式试验’(reportObj.testType === 'TYPETEST')，显示此字段->'DPA分解'/'型式试验'都可以显示 -->
                                <Col :span="18">
                                    <Row>
                                        <Col :span="8">
                                        <!-- 是否我司标准 -->
                                            <FormItem :label="$t('typeTestProcessSearch.t56')" prop="standardFlag" required>
                                                <Select v-model="reportObj.standardFlag" style="width: 50%;"
                                                        placeholder=""
                                                        :disabled="!dict.standardFlagList.length || btnDisabled"
                                                        @on-change="onStandardFlagChange">
                                                    <Option v-for="(item, index) in dict.standardFlagList" :value="item.value" :key="index">{{item.label}}
                                                    </Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="16">
                                            <span v-if="reportObj.standardFlag ==='N'" style="color:red;line-height: 32px;">
                                                *供方可选择不按照我司标准测试，且需承诺测试标准不低于我司标准
                                            </span>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
            </custom-panel>
            <custom-panel name="2" class="mg-t-20">
                <span style="color:red;">*</span>
                <!-- 测试的样品照片 -->
                {{$t('typeTestProcessSearch.t57')}}
                <div slot="content">
                    <Upload v-if="!readDisabled"
                            :action="uploadFileUrl1"
                            :format="fileTypeList"
                            ref="uploadFileRef"
                            :multiple="false"
                            :show-upload-list="false"
                            :before-upload="beforeUpload"
                            :on-progress="uploadProgress"
                            :on-error="failUpload"
                            :on-success="uploadSuccess"
                            :on-format-error="onFormatError"
                            :on-form-change="fileUpload"
                            :on-remove="removeFile"
                            :disabled="false">
                        <p v-for="(item, i) in this.uploadFiles" :key="i" style="diaplay:inline-block;margin-bottom:5px;">
                            <a href="javascript:void(0)" style="margin-right:2px;" @click.prevent="downloadFile(item.annexId)">
                                {{item.annexName}}
                                <!-- <Button size="small" type="primary" style="margin-left:15px;">下载</Button> -->
                            </a>
                            <!-- 删除 -->
                            <Button v-if="!btnDisabled" size="small" type="error" @click.stop="deleteFile(item.annexId)" :disabled="btnDisabled">
                                {{$t('commonTw.t5')}}
                            </Button>
                        </p>
                        <!-- 选择上传文件 -->
                        <Button type="ghost" icon="ios-cloud-upload-outline" :loading="uploadLoading" :disabled="btnDisabled">
                            {{$t('HSInspectManageMat.t36')}}
                        </Button>
                    </Upload>
                    <!-- 文件大小不能超过 10M -->
                    <span v-if="!readDisabled" style="color:red;">{{$t('typeTestProcessSearch.t58')}}</span>
                    <!-- <span v-if="!readDisabled" style="color:red;">jpeg, jpg, png, gif 格式文件，文件大小不能超过 10M</span> -->
                </div>
            </custom-panel>
            <custom-panel v-if="this.reportObj.testType === 'TYPETEST' || this.reportObj.testType === 'DPA'" name="3" class="mg-t-20">
                <!-- （试验类型是型式试验，属于我司标准，不需要上传供方报告 改为可上传非必填20221018） -->
                <span v-if="!(this.reportObj.testType === 'TYPETEST' && this.reportObj.standardFlag ==='Y')" style="color:red;">*</span>
                <!-- 供方报告附件 -->
                {{$t('typeTestProcessSearch.t59')}}
                <div slot="content">
                    <Upload v-if="!readDisabled"
                            :action="uploadFileUrl2"
                            :format="fileTypeList2"
                            ref="uploadFileRef2"
                            :multiple="false"
                            :show-upload-list="false"
                            :before-upload="beforeUpload2"
                            :on-progress="uploadProgress2"
                            :on-success="uploadSuccess2" :on-error="failUpload2"
                            :on-format-error="onFormatError2"
                            :on-form-change="fileUpload2"
                            :on-remove="removeFile2"
                            :disabled="false">
                        <p v-for="(item, i) in this.uploadFiles2" :key="i" style="diaplay:inline-block;margin-bottom:5px;">
                            <a href="javascript:void(0)" style="margin-right:2px;" @click.prevent="downloadFile2(item.annexId2)">
                                {{item.annexName2}}
                                <!-- <Button size="small" type="primary" style="margin-left:15px;">下载</Button> -->
                            </a>
                            <Button v-if="!btnDisabled" size="small" type="error" @click.stop="deleteFile2(item.annexId2)" :disabled="btnDisabled">
                                <!-- 删除 -->
                                {{$t('commonTw.t5')}}
                            </Button>
                        </p>
                        <Button type="ghost" icon="ios-cloud-upload-outline" :loading="uploadLoading2" :disabled="btnDisabled">
                            <!-- 选择上传文件 -->
                            {{$t('HSInspectManageMat.t36')}}
                        </Button>
                        <div v-if="this.reportObj.testType === 'DPA'" class="btn-dpa" @click.stop="">
                            <Button size="small" type="primary" @click.stop="downloadDPATemplateFile">
                                <!-- DPA报告模板下载 -->
                                {{$t('typeTestProcessSearch.t60')}}
                            </Button>
                        </div>
                    </Upload>
                    <span v-if="!readDisabled" style="color:red;">
                        <!-- 文件大小不能超过 10M -->
                        {{$t('typeTestProcessSearch.t58')}}
                    </span>
                    <!-- <span v-if="!readDisabled" style="color:red;">只能上传 xls, xlsx, doc, docx, jpeg, jpg, png, gif, pdf, txt, xml, rar, zip, 7z 格式文件，文件大小不能超过 10M</span> -->
                </div>
            </custom-panel>
            <custom-panel name="4" class="mg-t-20" :gutter="false">
                <!-- 计量检验 -->{{$t('typeTestProcessSearch.t61')}}
                <Button v-if="this.reportObj.standardFlag ==='N' && reportObj.reportStatus === 'WAITING'" size="small" type="primary" class="mg-l-30" @click.stop="addBtnClick1">
                    <!-- 新增行 -->{{$t('typeTestProcessSearch.t62')}}
                </Button>
                <div slot="content" class="table-wrap">
                    <mAssemblyTable
                        :columns="block.tableColumns"
                        :data="block.tableData"
                        :settings="block.settings"
                        :loading="block.loading"
                        :thDrag="true"
                        ref="blockRef"
                    ></mAssemblyTable>
                </div>
            </custom-panel>
            <custom-panel name="5" class="mg-t-20" :gutter="false">
                <!-- 计数检验 --> {{$t('typeTestProcessSearch.t63')}}
                <Button v-if="this.reportObj.standardFlag ==='N' && reportObj.reportStatus === 'WAITING'" size="small" type="primary" class="mg-l-30" @click.stop="addBtnClick2">
                    <!-- 新增行 --> {{$t('typeTestProcessSearch.t62')}}
                </Button>
                <div slot="content" class="table-wrap">
                    <mAssemblyTable
                        :columns="block2.tableColumns"
                        :data="block2.tableData"
                        :settings="block2.settings"
                        :loading="block2.loading"
                        :thDrag="true"
                        ref="blockRef2"
                    ></mAssemblyTable>
                </div>
            </custom-panel>
            <custom-panel name="6" class="mg-t-20">
                <!-- 美的图片附件 --> {{$t('typeTestProcessSearch.t64')}}
                <div slot="content">
                    <ul v-if="this.mideaPICdownloadList.length > 0" class="upload-list">
                        <li v-for="(file, index) in this.mideaPICdownloadList" :key="index"
                            class="upload-list-file upload-list-file-finish">
                            <a @click.prevent="downloadUploadListFile(file.fileId)">
                                <Icon :type="format(file)"></Icon> <span>{{file.name}}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </custom-panel>
        </div>
        <!-- 技术要求 -->
        <Modal
            v-model="modalTechnicalRequirement"
            :title="modalTechnicalRequirement_title"
            @on-ok="modalTechnicalRequirement_ok"
            @on-cancel="modalTechnicalRequirement_cancel" width="800"
            :mask-closable="false"
        >
            <div style="text-align:center">
                <Scroll>
                    <div align="justify" v-html="htmlTECHNICAL_REQUIREMENT">
                    </div>
                </Scroll>
            </div>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios';
import CustomPanel from '@/components/awesome/page/panel/index';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
// import api from '@/modules/gsc/api';
export default {
    name: 'typeTestProcessList',
    components: {
        CustomPanel,
        mAssemblyTable
    },
    data() {
        return {
            mdmCode: '',
            testTypeReqId: '',
            loading: false,
            dict: {
                testTypeList: [
                    {label: this.$t('typeTestProcessSearch.t2'), value: 'TYPETEST'}, // 型式试验
                    {label: this.$t('typeTestProcessSearch.t3'), value: 'DPA'}, // DPA分解
                ], // QMS结果过来的testType,testType=型式试验，DPA=DPA分解
                resultStatusList: [
                    {label: this.$t('typeTestProcessSearch.t65'), value: 'QUALIFIED'}, // 合格
                    {label: this.$t('typeTestProcessSearch.t66'), value: 'UNQUALIFIED'}, // 不合格
                ], // 综合判断结果  QUALIFIED：合格  UNQUALIFIED：不合格
                standardFlagList: [
                    {label: this.$t('typeTestProcessSearch.t67'), value: 'Y'}, // 是
                    {label: this.$t('typeTestProcessSearch.t68'), value: 'N'}, // 否
                ], // 是否我司标准
            },
            reportObj: {
                divName: '', // 事业部
                examinedNo: '', // 检验单号
                itemCode: '',
                itemDesc: '',
                testType: '', // 试验类型
                dataSource: '', // 单据来源
                releaseUser: '', // 发布人
                releaseDate: '', // 发布时间
                releaseDateStr: '', // 发布时间
                reportUploadDate: '', // 计划报告上传日期
                reportUploadDateStr: '', // 计划报告上传日期
                sampleQty: '', // 样本数量
                examinedUser: '', // 检验员
                supplierBatchNumber: '', // 生产批次号
                stateResult: '', // 检验单有效性
                datetimeModified: '', // 最后修改时间
                datetimeModifiedStr: '', // 最后修改时间
                lastUpdatedBy: '', // 最后修改人
                rejectCount: '', // 驳回次数
                rejectReason: '', // 驳回原因
                mainJudge: '', // 综合判断结果value
                mainJudgeName: '', // 综合判断结果name
                standardFlag: '', // 是否我司标准
                gscTypeTestDetailInfoList: [
                    // { fileType: '', fileId: '', fileName: '', }
                ],// 文件类型(TEST 测试的样品照片 REPORT 供方报告附件)
                gscTypeTestFileInfoList: [],// 主信息附件信息
            },
            mideaPICdownloadList: [],
            reportObjCopy: {},
            reportRules: {
                examinedUser: [
                    { required: true, message: this.$t('typeTestProcessSearch.t69'), trigger: 'blur' } // 检验员不能为空
                ],
                supplierBatchNumber: [
                    { required: true, message: this.$t('typeTestProcessSearch.t70'), trigger: 'blur' } // 生产批次号不能为空
                ],
                mainJudgeName: [
                    { required: false, message: this.$t('typeTestProcessSearch.t71'), trigger: 'blur' } // 综合判断结果不能为空
                ],
                standardFlag: [
                    { required: true, type: 'string', message: this.$t('typeTestProcessSearch.t72'), trigger: 'change' } // 是否我司标准不能为空
                ],
            },
            // 附件
            readDisabled: false,
            fileTypeList: [ 'jpeg', 'jpg', 'png', 'gif'],
            fileTypeList2: ['xls', 'xlsx', 'doc', 'docx', 'jpeg', 'jpg', 'png', 'gif', 'pdf', 'txt', 'xml', 'rar', 'zip', '7z'],
            uploadFiles: [],    // 测试的样品照片附件
            uploadFiles2: [],    // 供方报告附件
            // annexId: '',        // 测试的样品照片附件ID
            // annexId2: '',        // 供方报告附件ID
            uploadLoading: false,
            uploadLoading2: false,
            uploadFileUrl: '/qms2gsc/file/upload',
            uploadFileUrl1: '',
            uploadFileUrl2: '',
            uploadFileUrl3: '',
            downloadStandardsItemFileUrl: '/qms2gsc/file/download?id=',
            // downloadStandardsItemFileUrl: '/qms2gsc/file/download?id=',
            // 列表
            block: {
                settings: {
                    needPager: false,
                    showElevator: false,
                    showSizer: false,
                    pageSizeOpts: [10, 30, 50, 80],
                    needSearch: false,
                    needValidation: false,
                    needTable: true,
                    loading: false,
                    onlyLeftPart: false,
                    currentPage: 1,
                    pageSize: 10,
                    total: 0
                },
                tableColumns: {
                    showCheckbox: false,
                    showButtons: true,
                    columns: [
                        {
                            title: this.$t('commonTw.t6'),
                            key: 'num',
                            align: 'center',
                            minWidth: 40
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t73'), // 项目类别
                            key: 'itemsCategory',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                // let disabled = params.row.sourceType === 'QMS' || params.row.sourceType === 'GSC';
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.itemsCategory,
                                            disabled:!params.row.itemsCategory,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.itemsCategory,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.itemsCategory = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                    console.log('项目类别_this.block.tableData::', this.block.tableData);
                                                    // this.$set(this.block.tableData, params.index, params.row);
                                                }
                                            }
                                        })
                                    ]);
                                //// 新增行是否可编辑 sourceType：'QMS'(QMS返回)，'GSC'（GSC新增）
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.itemsCategory,
                                            disabled: !params.row.itemsCategory,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.itemsCategory);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t74'), // 检验类型
                            key: 'examinedType',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.examinedType,
                                            disabled:!params.row.examinedType,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.examinedType,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.examinedType = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.examinedType,
                                            disabled: !params.row.examinedType,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.examinedType);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t75'), // 检验属性
                            key: 'examinedProperty',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.examinedProperty,
                                            disabled:!params.row.examinedProperty,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.examinedProperty,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.examinedProperty = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.examinedProperty,
                                            disabled: !params.row.examinedProperty,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.examinedProperty);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t76'), // 项目名称
                            key: 'itemsName',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.itemsName,
                                            disabled:!params.row.itemsName,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.itemsName,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.itemsName = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.itemsName,
                                            disabled: !params.row.itemsName,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.itemsName);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t77'), // 技术要求
                            key: 'technicalRequirement',
                            tooltip: true,
                            align: 'center',
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.technicalRequirement,
                                            disabled:!params.row.technicalRequirement,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.technicalRequirement,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.technicalRequirement = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                let iconBtn = h('Button',
                                    {
                                        props: {
                                            type: 'text',
                                            icon: 'eye',
                                            disabled: false
                                        },
                                        style: {color:'#2d8cf0',fontSize:'32px',padding: '0 5px',lineHeight:'1'},
                                        on: {
                                            click: () => {
                                                this.showTECHNICAL_REQUIREMENT(params.row.technicalRequirement);
                                            }
                                        }
                                    }
                                );
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return iconBtn;
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t37'), // 特性分级
                            key: 'itemsLevel',
                            align: 'center',
                            tooltip: true,
                            minWidth: 70,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.itemsLevel,
                                            disabled:!params.row.itemsLevel,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.itemsLevel,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.itemsLevel = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.itemsLevel,
                                            disabled: !params.row.itemsLevel,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.itemsLevel);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t78'), // 检验工具
                            key: 'examinedTool',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.examinedTool,
                                            disabled:!params.row.examinedTool,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.examinedTool,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.examinedTool = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.examinedTool,
                                            disabled: !params.row.examinedTool,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.examinedTool);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t79'), // 检验依据
                            key: 'examinedBasis',
                            tooltip: true,
                            minWidth: 150,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.examinedBasis,
                                            disabled:!params.row.examinedBasis,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.examinedBasis,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.examinedBasis = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.examinedBasis,
                                            disabled: !params.row.examinedBasis,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.examinedBasis);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t80'), // 检验水平
                            key: 'inspectionLevel',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.inspectionLevel,
                                            disabled:!params.row.inspectionLevel,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.inspectionLevel,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.inspectionLevel = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.inspectionLevel,
                                            disabled: !params.row.inspectionLevel,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.inspectionLevel);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t81'), // 缺陷等级
                            key: 'ngLevel',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.ngLevel,
                                            disabled:!params.row.ngLevel,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.ngLevel,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.ngLevel = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.ngLevel,
                                            disabled: !params.row.ngLevel,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.ngLevel);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t82'), // 样本数
                            key: 'sampleQty',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let ipt = h('Input', {
                                    props: {
                                        value: params.row.sampleQty,
                                        size: 'small',
                                        type: 'text',
                                        disabled: false,
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let iptVal = event.target.value;
                                            if (isNaN(iptVal) || !this.validatePositive(iptVal)) {
                                                this.showTips(this.$t('typeTestProcessSearch.t83')); // 样本数请输入正整数
                                                event.target.value = '';
                                                params.row.sampleQty = null;
                                                return false;
                                            }
                                            params.row.sampleQty = parseFloat(iptVal);
                                            this.block.tableData[params.index] = params.row;
                                        }
                                    }
                                });
                                if (!params.row.sourceType) {
                                    return ipt;
                                } else {
                                    return h('span', {}, params.row.sampleQty);
                                }
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                let spanX = this.createSpanX(h);
                                let span = this.createSpan(h, params);
                                return h("div", {}, [spanX, span]);
                            },
                            title: this.$t('typeTestProcessSearch.t31'), // 检验结果
                            key: 'examinedStatus',
                            tooltip: true,
                            minWidth: 70,
                            render: (h, params) => {
                                // 是我司标准且qms返回，或者非我司标准gsc新增
                                // params.row.sourceType === 'QMS' || params.row.sourceType === 'GSC';
                                let disabled = !((this.reportObj.standardFlag === 'Y' && params.row.sourceType === 'QMS') || (this.reportObj.standardFlag === 'N' && !params.row.sourceType));
                                let select = h('Select',
                                    {
                                        props: {
                                            value: params.row.examinedStatus,
                                            size: 'small',
                                            filterable: true,
                                            labelInValue: true,
                                            placeholder: '',
                                            disabled: disabled || this.btnDisabled
                                        },
                                        on: {
                                            'on-change': (val) => {
                                                console.log('检验结果_val::', val);
                                                params.row.examinedStatus = val.value;
                                                // this.$set(this.block.tableData, params.index, params.row);
                                                this.block.tableData[params.index] = Object.assign({}, params.row);
                                                this.checkedResultChange(params.row, params.index, val.value, '1');
                                            },
                                        },
                                    },
                                    [
                                        this.checkResultList.map((item) => {
                                            return h('Option', {
                                                props: {
                                                    value: item.value,
                                                    label: item.label,
                                                },
                                            });
                                        }),
                                    ]
                                );
                                return select;
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                let spanX = this.createSpanX(h);
                                let span = this.createSpan(h, params);
                                return h("div", {}, [spanX, span]);
                            },
                            title: this.$t('typeTestProcessSearch.t84'), // 缺陷描述/不合格原因
                            key: 'ngInfo',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                // 是我司标准且qms返回，或者非我司标准gsc新增
                                let disabled = !((this.reportObj.standardFlag === 'Y' && params.row.sourceType === 'QMS') || (this.reportObj.standardFlag === 'N' && !params.row.sourceType));
                                let isNG = params.row.examinedStatus === 'NG';
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.ngInfo,
                                            disabled:!params.row.ngInfo,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.ngInfo,
                                                size: 'small',
                                                type: 'text',
                                                disabled: disabled || !isNG || this.btnDisabled,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.ngInfo = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                return inputTip;
                                // if (disabled) {
                                //     return h('Tooltip',{
                                //         props:{
                                //             content: params.row.ngInfo,
                                //             disabled: !params.row.ngInfo,
                                //         },
                                //         class: 'm-tooltip-overflow'
                                //     }, params.row.ngInfo);
                                // } else {
                                //     return inputTip;
                                // }
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                let spanX = this.createSpanX(h);
                                let span = this.createSpan(h, params);
                                return h("div", {}, [spanX, span]);
                            },
                            title: this.$t('typeTestProcessSearch.t85'), // 项目不良数
                            key: 'ngQty',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                // 是我司标准且qms返回，或者非我司标准gsc新增
                                let disabled = !((this.reportObj.standardFlag === 'Y' && params.row.sourceType === 'QMS') || (this.reportObj.standardFlag === 'N' && !params.row.sourceType));
                                let isNG = params.row.examinedStatus === 'NG';
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.ngQty,
                                            disabled:!params.row.ngQty,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.ngQty,
                                                size: 'small',
                                                type: 'text',
                                                disabled: disabled || !isNG || this.btnDisabled,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    let iptVal = event.target.value;
                                                    if (parseFloat(iptVal) > parseFloat(params.row.sampleQty)) {
                                                        this.showTips(this.$t('typeTestProcessSearch.t86')); // 项目不良数不能大于样本数
                                                        event.target.value = '';
                                                        params.row.ngQty = null;
                                                        return false;
                                                    }
                                                    if (iptVal && !isNaN(iptVal) && iptVal >= 0) {
                                                        params.row.ngQty = parseFloat(iptVal);
                                                        this.block.tableData[params.index] = params.row;
                                                    } else {
                                                        this.showTips(this.$t('typeTestProcessSearch.t87')); // 项目不良数必须大于或等于0
                                                        event.target.value = '';
                                                        params.row.ngQty = null;
                                                        this.block.tableData[params.index] = params.row;
                                                    }
                                                    // let iptVal = event.target.value;
                                                    // let testRules = /^\d+$/;
                                                    // if (isNaN(iptVal) || !testRules.test(iptVal)) {
                                                    //     this.showTips('项目不良数请输入整数');
                                                    //     event.target.value = '';
                                                    //     params.row.ngQty = null;
                                                    //     return false;
                                                    // }
                                                    // params.row.ngQty = parseFloat(iptVal);
                                                    // this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                return inputTip;
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t88'), // 项目附注
                            key: 'remark',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                // 是我司标准且qms返回，或者非我司标准gsc新增
                                let disabled = !((this.reportObj.standardFlag === 'Y' && params.row.sourceType === 'QMS') || (this.reportObj.standardFlag === 'N' && !params.row.sourceType));
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.remark,
                                            disabled:!params.row.remark,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.remark,
                                                size: 'small',
                                                type: 'text',
                                                disabled: disabled || this.btnDisabled,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.remark = event.target.value;
                                                    this.block.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                return inputTip;
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t89'), // 最小值
                            key: 'itemsPropertyFloor',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let ipt = h('Input', {
                                    props: {
                                        value: params.row.itemsPropertyFloor,
                                        size: 'small',
                                        type: 'text',
                                        disabled: false,
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let iptVal = event.target.value;
                                            let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
                                            if (isNaN(iptVal) || !numberRule.test(iptVal)) {
                                                this.showTips(this.$t('typeTestProcessSearch.t90')); // 最小值必须为有效数值
                                                event.target.value = '';
                                                params.row.itemsPropertyFloor = null;
                                                return false;
                                            }
                                            params.row.itemsPropertyFloor = parseFloat(iptVal);
                                            this.block.tableData[params.index] = params.row;
                                        }
                                    }
                                });
                                if (!params.row.sourceType) {
                                    return ipt;
                                } else {
                                    return h('span', {}, params.row.itemsPropertyFloor);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t91'), // 最大值
                            key: 'itemsPropertyCeiling',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let ipt = h('Input', {
                                    props: {
                                        value: params.row.itemsPropertyCeiling,
                                        size: 'small',
                                        type: 'text',
                                        disabled: false,
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let iptVal = event.target.value;
                                            let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
                                            if (isNaN(iptVal) || !numberRule.test(iptVal)) {
                                                this.showTips(this.$t('typeTestProcessSearch.t92')); // 最大值必须为有效数值
                                                event.target.value = '';
                                                params.row.itemsPropertyCeiling = null;
                                                return false;
                                            }
                                            params.row.itemsPropertyCeiling = parseFloat(iptVal);
                                            this.block.tableData[params.index] = params.row;
                                        }
                                    }
                                });
                                if (!params.row.sourceType) {
                                    return ipt;
                                } else {
                                    return h('span', {}, params.row.itemsPropertyCeiling);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t93'), // 基准值
                            key: 'itemsPropertyBenchmark',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let ipt = h('Input', {
                                    props: {
                                        value: params.row.itemsPropertyBenchmark,
                                        size: 'small',
                                        type: 'text',
                                        disabled: false,
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let iptVal = event.target.value;
                                            let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
                                            if (isNaN(iptVal) || !numberRule.test(iptVal)) {
                                                this.showTips(this.$t('typeTestProcessSearch.t94')); // 基准值必须为有效数值
                                                event.target.value = '';
                                                params.row.itemsPropertyBenchmark = null;
                                                return false;
                                            }
                                            params.row.itemsPropertyBenchmark = parseFloat(iptVal);
                                            this.block.tableData[params.index] = params.row;
                                        }
                                    }
                                });
                                if (!params.row.sourceType) {
                                    return ipt;
                                } else {
                                    return h('span', {}, params.row.itemsPropertyBenchmark);
                                }
                            }
                        },
                        {
                            title: 'ac',
                            key: 'ac',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let ipt = h('Input', {
                                    props: {
                                        value: params.row.ac,
                                        size: 'small',
                                        type: 'text',
                                        disabled: false,
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let iptVal = event.target.value;
                                            let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
                                            if (isNaN(iptVal) || !numberRule.test(iptVal)) {
                                                this.showTips(this.$t('typeTestProcessSearch.t96')); // ac必须为有效数值
                                                event.target.value = '';
                                                params.row.ac = null;
                                                return false;
                                            }
                                            params.row.ac = parseFloat(iptVal);
                                            this.block.tableData[params.index] = params.row;
                                        }
                                    }
                                });
                                if (!params.row.sourceType) {
                                    return ipt;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.ac,
                                            disabled: !params.row.ac,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.ac);
                                }
                            }
                        },
                        {
                            title: 're',
                            key: 're',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let ipt = h('Input', {
                                    props: {
                                        value: params.row.re,
                                        size: 'small',
                                        type: 'text',
                                        disabled: false,
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let iptVal = event.target.value;
                                            let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
                                            if (isNaN(iptVal) || !numberRule.test(iptVal)) {
                                                this.showTips(this.$t('typeTestProcessSearch.t98')); // re必须为有效数值
                                                event.target.value = '';
                                                params.row.re = null;
                                                return false;
                                            }
                                            params.row.re = parseFloat(iptVal);
                                            this.block.tableData[params.index] = params.row;
                                        }
                                    }
                                });
                                if (!params.row.sourceType) {
                                    return ipt;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.re,
                                            disabled: !params.row.re,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.re);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t99'), // 单位
                            key: 'itemsPropertyUom',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let ipt = h('Input', {
                                    props: {
                                        value: params.row.itemsPropertyUom,
                                        size: 'small',
                                        type: 'text',
                                        disabled: false,
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            params.row.itemsPropertyUom = event.target.value;
                                            this.block.tableData[params.index] = params.row;
                                        }
                                    }
                                });
                                if (!params.row.sourceType) {
                                    return ipt;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.itemsPropertyUom,
                                            disabled: !params.row.itemsPropertyUom,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.itemsPropertyUom);
                                }
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                let spanX = this.createSpanX(h);
                                let span = this.createSpan(h, params);
                                return h("div", {}, [spanX, span]);
                            },
                            title: this.$t('typeTestProcessSearch.t100'), // 测试后实物图片
                            key: 'fileId',
                            tooltip: true,
                            minWidth: 200,
                            render: (h, params) => {
                                // 是我司标准且qms返回，或者非我司标准gsc新增
                                let disabled = !((this.reportObj.standardFlag === 'Y' && params.row.sourceType === 'QMS') || (this.reportObj.standardFlag === 'N' && !params.row.sourceType));
                                let isNA = params.row.examinedStatus === 'NA';
                                let uploadUrl = '';
                                if (params.row.sourceType === 'QMS') {
                                    uploadUrl = this.uploadFileUrl + `?busid=${params.row.id}`;
                                } else {
                                    uploadUrl = this.uploadFileUrl + `?busid=${this.reportObj.id}&ref_data_type=${(params.row.id ? params.row.id : '')}`;
                                }
                                let upLoad = h('Upload', {
                                    props: {
                                        action: uploadUrl,
                                        format: this.fileTypeList,
                                        showUploadList: false,
                                        beforeUpload: (file) => {
                                            console.log('beforeUpload::', file);
                                            if (file.size > 10485760) {
                                                this.$Message.warning({
                                                    title: this.$t('common.warn'),
                                                    content: this.$t('typeTestProcessSearch.t58') // 文件大小不能超过10M！
                                                });
                                                return false;
                                            }
                                        },
                                        onProgress: () => {
                                            params.row.uploadLoading = true;
                                        },
                                        onSuccess: (response, file) => {
                                            let jsonStr = response.substring(1).substring(0, response.length - 3);
                                            let result = JSON.parse(jsonStr);
                                            if (result.IsSucess) {
                                                params.row.fileName = file.name;
                                                params.row.fileId = result.MainResultData;
                                                this.$set(this.block.tableData, params.index, params.row);
                                                this.$Message.success(this.$t('typeTestProcessSearch.t101')); // 文件已上传
                                                this.reportSubmit('TS', false);
                                            } else {
                                                this.showTips();
                                            }
                                            params.row.uploadLoading = false;
                                        },
                                        onFormatError: () => {
                                            this.$Modal.error({
                                                content: this.$t('typeTestProcessSearch.t102').replace('#name', this.uploadFormat.join()), // `附件只支持${this.uploadFormat.join()}格式` // 附件只支持_格式
                                            });
                                        },
                                        onError: () => {
                                            params.row.uploadLoading = false;
                                            this.$set(this.block.tableData, params.index, params.row);
                                            this.$Message.warning(this.$t('typeTestProcessSearch.t103')); // 上传失败
                                        }
                                    }
                                }, [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            icon: 'upload',
                                            loading: params.row.uploadLoading,
                                            disabled: disabled || isNA
                                        },
                                        style: {
                                            fontSize: '16px',padding: '0 5px'
                                        }
                                    })
                                ]);
                                let fileName = h('a', {
                                    attrs: {
                                        href: this.downloadStandardsItemFileUrl + params.row.fileId
                                    }
                                }, params.row.fileName);
                                let delIcon = h('Button', {
                                    props: {
                                        type: 'text',
                                        icon: 'close',
                                        disabled: disabled || isNA || this.btnDisabled,
                                    },
                                    on: {
                                        click: () => {
                                            axios.post('/qms2gsc/file/delete' + '?id=' + params.row.fileId + '&deletefile=Y', {})
                                            .then(res => {
                                                let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
                                                let result = JSON.parse(jsonStr);
                                                var IsSucess = result.IsSucess;
                                                if (IsSucess === true) {
                                                    params.row.fileId = '';
                                                    params.row.fileName = '';
                                                    this.$set(this.block.tableData, params.index, params.row);
                                                    this.$Message.success(this.$t('typeTestProcessSearch.t129')); // 删除成功
                                                    this.reportSubmit('TS', false);
                                                } else {
                                                    this.$Modal.error({
                                                        title: this.$t('common.warn'),
                                                        content: this.$t('typeTestProcessSearch.t104') // 删除失败
                                                    });
                                                }
                                            }).catch(() => {
                                                this.$Modal.error({
                                                    title: this.$t('common.warn'),
                                                    content: this.$t('common.error1')
                                                });
                                            });
                                        }
                                    }
                                });
                                if (!params.row.fileId) {
                                    return upLoad; // gsc新增行上传
                                } else {
                                    return h('div', {}, [fileName, delIcon]);  // 编辑
                                }
                            }
                        },
                        {
                            title: this.$t('HSInspectManageMat.t54'), // 操作
                            key: 'opt',
                            align: 'center',
                            minWidth: 60,
                            render: (h, params) => {
                                // 判断非我司标准gsc新增的暂存数据
                                let isGSCTemp = this.reportObj.standardFlag === 'N' && params.row.sourceType === 'GSC' && this.reportObj.reportStatus === 'WAITING';
                                let del2 = h('Button',
                                    {
                                        props: {
                                            type: 'text',
                                            icon: 'trash-b',
                                            disabled: false
                                        },
                                        style: {fontSize: '16px',padding: '0 5px'},
                                        on: {
                                            click: () => {
                                                this.$Modal.confirm({
                                                    title: this.$t('common.warn'),
                                                    content: this.$t('typeTestProcessSearch.t105'), // 您确认删除这条内容吗？
                                                    onOk: () => {
                                                        this.block.tableData.splice(params.index, 1);
                                                    }
                                                });
                                            }
                                        }
                                    }
                                );
                                if (params.row.isGSCAdd || isGSCTemp) {
                                    return del2;
                                }
                            }
                        }
                    ]
                },
                tableData: [],
                loading: false,
                condition: {},
            },
            block2: {
                settings: {
                    needPager: false,
                    showElevator: false,
                    showSizer: false,
                    pageSizeOpts: [10, 30, 50, 80],
                    needSearch: false,
                    needValidation: false,
                    needTable: true,
                    loading: false,
                    onlyLeftPart: false,
                    currentPage: 1,
                    pageSize: 10,
                    total: 0
                },
                tableColumns: {
                    showCheckbox: false,
                    showButtons: true,
                    columns: [
                        {
                            title: this.$t('commonTw.t6'), // 序号
                            key: 'num',
                            align: 'center',
                            minWidth: 40
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t73'), // 项目类别
                            key: 'itemsCategory',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.itemsCategory,
                                            disabled:!params.row.itemsCategory,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.itemsCategory,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.itemsCategory = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                    console.log('项目类别_this.block2.tableData::', this.block2.tableData);
                                                    // this.$set(this.block2.tableData, params.index, params.row);
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.itemsCategory,
                                            disabled: !params.row.itemsCategory,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.itemsCategory);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t74'), // 检验类型
                            key: 'examinedType',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.examinedType,
                                            disabled:!params.row.examinedType,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.examinedType,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.examinedType = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.examinedType,
                                            disabled: !params.row.examinedType,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.examinedType);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t75'), // 检验属性
                            key: 'examinedProperty',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.examinedProperty,
                                            disabled:!params.row.examinedProperty,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.examinedProperty,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.examinedProperty = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.examinedProperty,
                                            disabled: !params.row.examinedProperty,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.examinedProperty);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t76'), // 项目名称
                            key: 'itemsName',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.itemsName,
                                            disabled:!params.row.itemsName,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.itemsName,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.itemsName = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.itemsName,
                                            disabled: !params.row.itemsName,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.itemsName);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t77'), // 技术要求
                            key: 'technicalRequirement',
                            tooltip: true,
                            align: 'center',
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.technicalRequirement,
                                            disabled:!params.row.technicalRequirement,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.technicalRequirement,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.technicalRequirement = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                let iconBtn = h('Button',
                                    {
                                        props: {
                                            type: 'text',
                                            icon: 'eye',
                                            disabled: false
                                        },
                                        style: {color:'#2d8cf0',fontSize:'32px',padding: '0 5px',lineHeight:'1'},
                                        on: {
                                            click: () => {
                                                this.showTECHNICAL_REQUIREMENT(params.row.technicalRequirement);
                                            }
                                        }
                                    }
                                );
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return iconBtn;
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t37'), // 特性分级
                            key: 'itemsLevel',
                            align: 'center',
                            tooltip: true,
                            minWidth: 70,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.itemsLevel,
                                            disabled:!params.row.itemsLevel,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.itemsLevel,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.itemsLevel = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.itemsLevel,
                                            disabled: !params.row.itemsLevel,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.itemsLevel);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t78'), // 检验工具
                            key: 'examinedTool',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.examinedTool,
                                            disabled:!params.row.examinedTool,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.examinedTool,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.examinedTool = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.examinedTool,
                                            disabled: !params.row.examinedTool,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.examinedTool);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t79'), // 检验依据
                            key: 'examinedBasis',
                            tooltip: true,
                            minWidth: 150,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.examinedBasis,
                                            disabled:!params.row.examinedBasis,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.examinedBasis,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.examinedBasis = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.examinedBasis,
                                            disabled: !params.row.examinedBasis,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.examinedBasis);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t80'), // 检验水平
                            key: 'inspectionLevel',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.inspectionLevel,
                                            disabled:!params.row.inspectionLevel,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.inspectionLevel,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.inspectionLevel = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.inspectionLevel,
                                            disabled: !params.row.inspectionLevel,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.inspectionLevel);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t81'), // 缺陷等级
                            key: 'ngLevel',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.ngLevel,
                                            disabled:!params.row.ngLevel,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.ngLevel,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.ngLevel = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.ngLevel,
                                            disabled: !params.row.ngLevel,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.ngLevel);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t82'), // 样本数
                            key: 'sampleQty',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let ipt = h('Input', {
                                    props: {
                                        value: params.row.sampleQty,
                                        size: 'small',
                                        type: 'text',
                                        disabled: false,
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let iptVal = event.target.value;
                                            if (isNaN(iptVal) || !this.validatePositive(iptVal)) {
                                                this.showTips(this.$t('typeTestProcessSearch.t83')); // 样本数请输入正整数
                                                event.target.value = '';
                                                params.row.sampleQty = null;
                                                return false;
                                            }
                                            if (parseFloat(iptVal) < parseFloat(params.row.ngQty)) {
                                                this.showTips(this.$t('typeTestProcessSearch.t86')); // 项目不良数不能大于样本数
                                                event.target.value = '';
                                                params.row.sampleQty = null;
                                                return false;
                                            }
                                            params.row.sampleQty = parseFloat(iptVal);
                                            this.block2.tableData[params.index] = params.row;
                                        }
                                    }
                                });
                                if (!params.row.sourceType) {
                                    return ipt;
                                } else {
                                    return h('span', {}, params.row.sampleQty);
                                }
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                let spanX = this.createSpanX(h);
                                let span = this.createSpan(h, params);
                                return h("div", {}, [spanX, span]);
                            },
                            title: this.$t('typeTestProcessSearch.t31'), // 检验结果
                            key: 'examinedStatus',
                            tooltip: true,
                            minWidth: 70,
                            render: (h, params) => {
                                // 是我司标准且qms返回，或者非我司标准gsc新增
                                let disabled = !((this.reportObj.standardFlag === 'Y' && params.row.sourceType === 'QMS') || (this.reportObj.standardFlag === 'N' && !params.row.sourceType));
                                let select = h('Select',
                                    {
                                        props: {
                                            value: params.row.examinedStatus,
                                            size: 'small',
                                            filterable: true,
                                            labelInValue: true,
                                            placeholder: '',
                                            disabled: disabled || this.btnDisabled
                                        },
                                        on: {
                                            'on-change': (val) => {
                                                console.log('检验结果_val::', val);
                                                params.row.examinedStatus = val.value;
                                                this.$set(this.block2.tableData, params.index, params.row);
                                                // this.block2.tableData[params.index] = Object.assign({}, params.row);
                                                this.checkedResultChange(params.row, params.index, val.value, '2');
                                            },
                                        },
                                    },
                                    [
                                        this.checkResultList.map((item) => {
                                            return h('Option', {
                                                props: {
                                                    value: item.value,
                                                    label: item.label,
                                                },
                                            });
                                        }),
                                    ]
                                );
                                return select;
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                let spanX = this.createSpanX(h);
                                let span = this.createSpan(h, params);
                                return h("div", {}, [spanX, span]);
                            },
                            title: this.$t('typeTestProcessSearch.t84'), // 缺陷描述/不合格原因
                            key: 'ngInfo',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                // 是我司标准且qms返回，或者非我司标准gsc新增
                                let disabled = !((this.reportObj.standardFlag === 'Y' && params.row.sourceType === 'QMS') || (this.reportObj.standardFlag === 'N' && !params.row.sourceType));
                                let isNG = params.row.examinedStatus === 'NG';
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.ngInfo,
                                            disabled:!params.row.ngInfo,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.ngInfo,
                                                size: 'small',
                                                type: 'text',
                                                disabled: disabled || !isNG || this.btnDisabled,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.ngInfo = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                return inputTip;
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                let spanX = this.createSpanX(h);
                                let span = this.createSpan(h, params);
                                return h("div", {}, [spanX, span]);
                            },
                            title: this.$t('typeTestProcessSearch.t85'), // 项目不良数
                            key: 'ngQty',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                // 是我司标准且qms返回，或者非我司标准gsc新增
                                let disabled = !((this.reportObj.standardFlag === 'Y' && params.row.sourceType === 'QMS') || (this.reportObj.standardFlag === 'N' && !params.row.sourceType));
                                let isNG = params.row.examinedStatus === 'NG';
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.ngQty,
                                            disabled:!params.row.ngQty,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.ngQty,
                                                size: 'small',
                                                type: 'text',
                                                disabled: disabled || !isNG || this.btnDisabled,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    let iptVal = event.target.value;
                                                    if (parseFloat(iptVal) > parseFloat(params.row.sampleQty)) {
                                                        this.showTips(this.$t('typeTestProcessSearch.t86')); // 项目不良数不能大于样本数
                                                        event.target.value = '';
                                                        params.row.ngQty = null;
                                                        return false;
                                                    }
                                                    if (iptVal && !isNaN(iptVal) && iptVal >= 0) {
                                                        params.row.ngQty = parseFloat(iptVal);
                                                        this.block2.tableData[params.index] = params.row;
                                                    } else {
                                                        this.showTips(this.$t('typeTestProcessSearch.t87')); // 项目不良数必须大于或等于0
                                                        event.target.value = '';
                                                        params.row.ngQty = null;
                                                        this.block2.tableData[params.index] = params.row;
                                                    }
                                                    // this.ngqtyOnChange(iptVal, params.index);
                                                }
                                            }
                                        })
                                    ]);
                                return inputTip;
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t88'), // 项目附注
                            key: 'remark',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                // 是我司标准且qms返回，或者非我司标准gsc新增
                                let disabled = !((this.reportObj.standardFlag === 'Y' && params.row.sourceType === 'QMS') || (this.reportObj.standardFlag === 'N' && !params.row.sourceType));
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.remark,
                                            disabled:!params.row.remark,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.remark,
                                                size: 'small',
                                                type: 'text',
                                                disabled: disabled || this.btnDisabled,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.remark = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                return inputTip;
                            }
                        },
                        // {
                        //     title: '最小值',
                        //     key: 'itemsPropertyFloor',
                        //     tooltip: true,
                        //     minWidth: 100,
                        //     render: (h, params) => {
                        //         let ipt = h('Input', {
                        //             props: {
                        //                 value: params.row.itemsPropertyFloor,
                        //                 size: 'small',
                        //                 type: 'text',
                        //                 disabled: false,
                        //             },
                        //             on: {
                        //                 'on-blur': (event) => {
                        //                     let iptVal = event.target.value;
                        //                     let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
                        //                     if (isNaN(iptVal) || !numberRule.test(iptVal)) {
                        //                         this.showTips('最小值必须为有效数值');
                        //                         event.target.value = '';
                        //                         params.row.itemsPropertyFloor = null;
                        //                         return false;
                        //                     }
                        //                     params.row.itemsPropertyFloor = parseFloat(iptVal);
                        //                     this.block2.tableData[params.index] = params.row;
                        //                 }
                        //             }
                        //         });
                        //         if (!params.row.sourceType) {
                        //             return ipt;
                        //         } else {
                        //             return h('span', {}, params.row.itemsPropertyFloor);
                        //         }
                        //     }
                        // },
                        // {
                        //     title: '最大值',
                        //     key: 'itemsPropertyCeiling',
                        //     tooltip: true,
                        //     minWidth: 100,
                        //     render: (h, params) => {
                        //         let ipt = h('Input', {
                        //             props: {
                        //                 value: params.row.itemsPropertyCeiling,
                        //                 size: 'small',
                        //                 type: 'text',
                        //                 disabled: false,
                        //             },
                        //             on: {
                        //                 'on-blur': (event) => {
                        //                     let iptVal = event.target.value;
                        //                     let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
                        //                     if (isNaN(iptVal) || !numberRule.test(iptVal)) {
                        //                         this.showTips('最大值必须为有效数值');
                        //                         event.target.value = '';
                        //                         params.row.itemsPropertyCeiling = null;
                        //                         return false;
                        //                     }
                        //                     params.row.itemsPropertyCeiling = parseFloat(iptVal);
                        //                     this.block2.tableData[params.index] = params.row;
                        //                 }
                        //             }
                        //         });
                        //         if (!params.row.sourceType) {
                        //             return ipt;
                        //         } else {
                        //             return h('span', {}, params.row.itemsPropertyCeiling);
                        //         }
                        //     }
                        // },
                        // {
                        //     title: '基准值',
                        //     key: 'itemsPropertyBenchmark',
                        //     tooltip: true,
                        //     minWidth: 100,
                        //     render: (h, params) => {
                        //         let ipt = h('Input', {
                        //             props: {
                        //                 value: params.row.itemsPropertyBenchmark,
                        //                 size: 'small',
                        //                 type: 'text',
                        //                 disabled: false,
                        //             },
                        //             on: {
                        //                 'on-blur': (event) => {
                        //                     let iptVal = event.target.value;
                        //                     let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
                        //                     if (isNaN(iptVal) || !numberRule.test(iptVal)) {
                        //                         this.showTips('基准值必须为有效数值');
                        //                         event.target.value = '';
                        //                         params.row.itemsPropertyBenchmark = null;
                        //                         return false;
                        //                     }
                        //                     params.row.itemsPropertyBenchmark = parseFloat(iptVal);
                        //                     this.block2.tableData[params.index] = params.row;
                        //                 }
                        //             }
                        //         });
                        //         if (!params.row.sourceType) {
                        //             return ipt;
                        //         } else {
                        //             return h('span', {}, params.row.itemsPropertyBenchmark);
                        //         }
                        //     }
                        // },
                        {
                            title: 'ac',
                            key: 'ac',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.ac,
                                            disabled:!params.row.ac,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.ac,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    let iptVal = event.target.value;
                                                    let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
                                                    if (isNaN(iptVal) || !numberRule.test(iptVal)) {
                                                        this.showTips(this.$t('typeTestProcessSearch.t96')); // ac必须为有效数值
                                                        event.target.value = '';
                                                        params.row.ac = null;
                                                        return false;
                                                    }
                                                    params.row.ac = parseFloat(iptVal);
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.ac,
                                            disabled: !params.row.ac,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.ac);
                                }
                            }
                        },
                        {
                            title: 're',
                            key: 're',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.re,
                                            disabled:!params.row.re,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.re,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    let iptVal = event.target.value;
                                                    let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
                                                    if (isNaN(iptVal) || !numberRule.test(iptVal)) {
                                                        this.showTips(this.$t('typeTestProcessSearch.t98')); // re必须为有效数值
                                                        event.target.value = '';
                                                        params.row.re = null;
                                                        return false;
                                                    }
                                                    params.row.re = parseFloat(iptVal);
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.re,
                                            disabled: !params.row.re,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.re);
                                }
                            }
                        },
                        {
                            title: this.$t('typeTestProcessSearch.t99'), // 单位
                            key: 'itemsPropertyUom',
                            tooltip: true,
                            minWidth: 100,
                            render: (h, params) => {
                                let inputTip = h('Tooltip',{
                                        props:{
                                            content:params.row.itemsPropertyUom,
                                            disabled:!params.row.itemsPropertyUom,
                                        },
                                    },
                                    [
                                        h('Input', {
                                            props: {
                                                value: params.row.itemsPropertyUom,
                                                size: 'small',
                                                type: 'text',
                                                disabled: false,
                                            },
                                            on: {
                                                'on-blur': (event) => {
                                                    params.row.itemsPropertyUom = event.target.value;
                                                    this.block2.tableData[params.index] = params.row;
                                                }
                                            }
                                        })
                                    ]);
                                if (!params.row.sourceType) {
                                    return inputTip;
                                } else {
                                    return h('Tooltip',{
                                        props:{
                                            content: params.row.itemsPropertyUom,
                                            disabled: !params.row.itemsPropertyUom,
                                        },
                                        class: 'm-tooltip-overflow'
                                    }, params.row.itemsPropertyUom);
                                }
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                let spanX = this.createSpanX(h);
                                let span = this.createSpan(h, params);
                                return h("div", {}, [spanX, span]);
                            },
                            title: this.$t('typeTestProcessSearch.t100'), // 测试后实物图片
                            key: 'fileId',
                            tooltip: true,
                            minWidth: 200,
                            render: (h, params) => {
                                // 是我司标准且qms返回，或者非我司标准gsc新增
                                let disabled = !((this.reportObj.standardFlag === 'Y' && params.row.sourceType === 'QMS') || (this.reportObj.standardFlag === 'N' && !params.row.sourceType));
                                let isNA = params.row.examinedStatus === 'NA';
                                let uploadUrl = '';
                                if (params.row.sourceType === 'QMS') {
                                    uploadUrl = this.uploadFileUrl + `?busid=${params.row.id}`;
                                } else {
                                    uploadUrl = this.uploadFileUrl + `?busid=${this.reportObj.id}&ref_data_type=${(params.row.id ? params.row.id : '')}`;
                                }
                                let upLoad = h('Upload', {
                                    props: {
                                        action: uploadUrl,
                                        format: this.fileTypeList,
                                        showUploadList: false,
                                        beforeUpload: (file) => {
                                            console.log('beforeUpload::', file);
                                            if (file.size > 10485760) {
                                                this.$Message.warning({
                                                    title: this.$t('common.warn'),
                                                    content: this.$t('typeTestProcessSearch.t58') // 文件大小不能超过10M！
                                                });
                                                return false;
                                            }
                                        },
                                        onProgress: () => {
                                            params.row.uploadLoading = true;
                                        },
                                        onSuccess: (response, file) => {
                                            let jsonStr = response.substring(1).substring(0, response.length - 3);
                                            let result = JSON.parse(jsonStr);
                                            if (result.IsSucess) {
                                                params.row.fileName = file.name;
                                                params.row.fileId = result.MainResultData;
                                                this.$set(this.block2.tableData, params.index, params.row);
                                                this.$Message.success(this.$t('typeTestProcessSearch.t101')); // 文件已上传
                                                this.reportSubmit('TS', false);
                                            } else {
                                                this.showTips();
                                            }
                                            params.row.uploadLoading = false;
                                        },
                                        onFormatError: () => {
                                            this.$Modal.error({
                                                content: this.$t('typeTestProcessSearch.t102').replace('#name', this.uploadFormat.join()) // `附件只支持${this.uploadFormat.join()}格式` // 附件只支持_格式
                                            });
                                        },
                                        onError: () => {
                                            params.row.uploadLoading = false;
                                            this.$set(this.block2.tableData, params.index, params.row);
                                            this.$Message.warning(this.$t('typeTestProcessSearch.t103')); // 上传失败
                                        }
                                    }
                                }, [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            icon: 'upload',
                                            loading: params.row.uploadLoading,
                                            disabled: disabled || isNA
                                        },
                                        style: {
                                            fontSize: '16px',padding: '0 5px'
                                        }
                                    })
                                ]);
                                let fileName = h('a', {
                                    attrs: {
                                        href: this.downloadStandardsItemFileUrl + params.row.fileId
                                    }
                                }, params.row.fileName);
                                let delIcon = h('Button', {
                                    props: {
                                        type: 'text',
                                        icon: 'close',
                                        disabled: disabled || isNA || this.btnDisabled,
                                    },
                                    on: {
                                        click: () => {
                                            axios.post('/qms2gsc/file/delete' + '?id=' + params.row.fileId + '&deletefile=Y', {})
                                            .then(res => {
                                                let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
                                                let result = JSON.parse(jsonStr);
                                                var IsSucess = result.IsSucess;
                                                if (IsSucess === true) {
                                                    params.row.fileId = '';
                                                    params.row.fileName = '';
                                                    this.$set(this.block2.tableData, params.index, params.row);
                                                    this.$Message.success(this.$t('typeTestProcessSearch.t129')); // 删除成功
                                                    this.reportSubmit('TS', false);
                                                } else {
                                                    this.$Modal.error({
                                                        title: this.$t('common.warn'),
                                                        content: this.$t('typeTestProcessSearch.t104') // 删除失败
                                                    });
                                                }
                                            }).catch(() => {
                                                this.$Modal.error({
                                                    title: this.$t('common.warn'),
                                                    content: this.$t('common.error1')
                                                });
                                            });
                                        }
                                    }
                                });
                                if (!params.row.fileId) {
                                    return upLoad; // gsc新增行上传
                                } else {
                                    return h('div', {}, [fileName, delIcon]);  // 编辑
                                }
                            }
                        },
                        {
                            title: this.$t('HSInspectManageMat.t54'), // 操作
                            key: 'opt',
                            align: 'center',
                            minWidth: 60,
                            render: (h, params) => {
                                // 判断非我司标准gsc新增的暂存数据
                                let isGSCTemp = this.reportObj.standardFlag === 'N' && params.row.sourceType === 'GSC' && this.reportObj.reportStatus === 'WAITING';
                                let dele = h('Button',
                                    {
                                        props: {
                                            type: 'text',
                                            icon: 'trash-b',
                                            disabled: false
                                        },
                                        style: {fontSize: '16px',padding: '0 5px'},
                                        on: {
                                            click: () => {
                                                this.$Modal.confirm({
                                                    title: this.$t('common.warn'),
                                                    content: this.$t('typeTestProcessSearch.t105'), // 您确认删除这条内容吗？
                                                    onOk: () => {
                                                        this.block2.tableData.splice(params.index, 1);
                                                    }
                                                });
                                            }
                                        }
                                    }
                                );
                                if (params.row.isGSCAdd || isGSCTemp) {
                                    return dele;
                                }
                            }
                        }
                    ]
                },
                tableData: [],
                loading: false,
                condition: {},
            },
            checkResultList: [
                {value: 'OK', label: 'OK'},
                {value: 'NG', label: 'NG'},
                {value: 'NA', label: 'NA'}
            ],
            htmlTECHNICAL_REQUIREMENT: '',
            modalTechnicalRequirement: false,
            modalTechnicalRequirement_title: this.$t('typeTestProcessSearch.t77'), // 技术要求
            inputArrayList: [],
            inputArray: 0,
            btnDisabled: false,
        };
    },
    methods: {
        /** 试验类型切换 */
        onTestTypeChange(val) {
            console.log('onTestTypeChange_val:', val);
            // if (val === 'DPA') {
            //     // DPA分解,不显示且清空'是否我司标准'
            //     this.reportObj.standardFlag = '';
            // }
        },
        /** 综合判断结果 */
        onResultStatusChange() {
        },
        /** 是否我司标准切换 */
        onStandardFlagChange(val) {
            if (!val || val === 'Y') {
                // // （试验类型是型式试验，属于我司标准，不需要上传供方报告 改为可上传非必填20221018）
                // if (this.reportObj.testType === 'TYPETEST') {
                //     this.uploadFiles2 = [];
                // }
                this.block.tableData = this.block.tableData.filter(item => !item.isGSCAdd);
                this.block2.tableData = this.block2.tableData.filter(item => !item.isGSCAdd);
            }
            this.$set(this.reportObj, 'standardFlag', val);
        },
        // 创建‘*’
        createSpanX(h) {
            return h("span",
                {
                    props: {
                        size: 20,
                    },
                    style: {
                        color: "red",
                    },
                },
                "*"
            );
        },
        // 创建Span
        createSpan(h, params) {
            return h("span",
                {
                    props: {
                        size: 20,
                    },
                    style: {
                        "font-weight": "bold",
                    },
                },
                params.column.title
            );
        },
        // 创建Input: 默认是textarea
        createInput (h, params, colName, prop) {
            return h('Input', {
                props: {
                    value: params.row[colName],
                    size: 'small',
                    type: prop.type || 'textarea',
                    disabled: false
                },
                style: {
                    background: '#fbfbfb',
                    height: '100%'
                },
                on: {
                    'on-change': (event) => {
                        params.row[colName] = event.target.value;
                        prop.tableData[params.index] = params.row;
                    }
                }
            });
        },
        /** 计量检验新增行 */
        addBtnClick1() {
            this.loading = true;
            // /gscapp/gscTypeTestInfo/generateGscId
            axios.get('/gscint/gscTypeTestInfo/generateGscId')
            .then(res => {
                this.loading = false;
                if (res.data.data.code === '0') {
                    let id = res.data.data.data;
                    let meteringCLZObj = {};
                    let len = this.block.tableData.length + 1;
                    // 生成测量值个数
                    let testValueNum = 0;
                    if (this.block.tableData.length === 0) {
                        testValueNum = 5;
                        this.setSomeColumns(testValueNum);
                    } else {
                        testValueNum = this.inputArray.length;
                    }
                    for (let i = 0; i < testValueNum; i++) {
                        meteringCLZObj[`testValue${i+1}`] = '';
                    }
                    let addObj = {
                        isGSCAdd: true,
                        num: len, // 序号
                        typetestReqId: this.reportObj.id,
                        id: id,
                        testType: 'METER',
                        itemsCategory: '', // 项目类别
                        examinedType: '', // 检验类型
                        examinedProperty: '', // 检验属性
                        itemsName: '', // 项目名称
                        technicalRequirement: '', // 技术要求
                        itemsLevel: '', // 特性分级
                        examinedTool: '', // 检验工具
                        examinedBasis: '', // 检验依据
                        inspectionLevel: '', // 检验水平
                        ngLevel: '', // 缺陷等级
                        examinedStatus: '', // 检验结果value
                        ngInfo: '', // 缺陷描述
                        ngQty: '', // 项目不良数
                        remark: '', // 项目附注
                        // testValue1: '', // 测量值1
                        // testValue2: '', // 测量值2
                        // testValue3: '', // 测量值3
                        // testValue4: '', // 测量值4
                        // testValue5: '', // 测量值5
                        sampleQty: '', // 样本数
                        ac: '', // ac
                        re: '', // re
                        ITEMS_PROPERTY_CEILING_TERMS: "≤",
                        itemsPropertyCeiling: '', // 最大值
                        ITEMS_PROPERTY_FLOOR_TERMS: '≥',
                        itemsPropertyFloor: '', // 最小值
                        itemsPropertyBenchmark: '', // 基准值
                        itemsPropertyUom: '', // 单位
                        fileId: '',    // 测试后实物图片id
                        fileName: '',  // 测试后实物图片名称
                    }
                    Object.assign(addObj, meteringCLZObj);
                    this.block.tableData.unshift(addObj);
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('typeTestProcessSearch.t106') // 获取GSC_ID有误，请重新操作
                    });
                }
            }).catch(err => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1'),
                    error: err.stack.toString()
                });
            });
        },
        /** 计数检验新增行 */
        addBtnClick2() {
            this.loading = true;
            // /gscapp/gscTypeTestInfo/generateGscId
            axios.get('/gscint/gscTypeTestInfo/generateGscId')
            .then(res => {
                this.loading = false;
                if (res.data.data.code === '0') {
                    let id = res.data.data.data;
                    let len = this.block2.tableData.length + 1;
                    let addObj2 = {
                        isGSCAdd: true,
                        num: len, // 序号
                        typetestReqId: this.reportObj.id,
                        id: id,
                        testType: 'COUNT',
                        itemsCategory: '', // 项目类别
                        examinedType: '', // 检验类型
                        examinedProperty: '', // 检验属性
                        itemsName: '', // 项目名称
                        technicalRequirement: '', // 技术要求
                        itemsLevel: '', // 特性分级
                        examinedTool: '', // 检验工具
                        examinedBasis: '', // 检验依据
                        inspectionLevel: '', // 检验水平
                        ngLevel: '', // 缺陷等级
                        examinedStatus: '', // 检验结果value
                        ngInfo: '', // 缺陷描述
                        ngQty: '', // 项目不良数
                        remark: '', // 项目附注
                        sampleQty: '', // 样本数
                        ac: '', // ac
                        re: '', // re
                        // itemsPropertyCeiling: '', // 最大值
                        // itemsPropertyFloor: '', // 最小值
                        // itemsPropertyBenchmark: '', // 基准值
                        itemsPropertyUom: '', // 单位
                        fileId: '',    // 测试后实物图片id
                        fileName: '',  // 测试后实物图片名称
                    }
                    this.block2.tableData.unshift(addObj2);
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('typeTestProcessSearch.t106') // 获取GSC_ID有误，请重新操作
                    });
                }
            }).catch(err => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1'),
                    error: err.stack.toString()
                });
            });
        },
        /** 验证正整数 */
        validatePositive(val) {
            var rel = /^[1-9]*[1-9][0-9]*$/;
            return rel.test(val);
        },
        showTips (msg, key = 'loading') {
            this[key] = false;
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: msg || this.$t('common.error1')
            });
        },
        /**
        1.当‘试验类型’是‘型式试验’，并且不是我司标准，
        (this.reportObj.testType === 'TYPETEST' && this.reportObj.standardFlag ==='N')
        2.或当试验类型是’ DPA分解’，则GSC端上传报告附件；（试验类型是型式试验，属于我司标准，不需要上传供方报告 改为可上传非必填20221018）
        (this.reportObj.testType === 'DPA')
        */
        validRow() {
            let flag = true;
            this.$refs.reportForm.validate((valid) => {
                if (valid) {
                    console.log('this.block.tableData::', this.block.tableData);
                    console.log('this.block2.tableData::', this.block2.tableData);
                    let notStandardFlag = this.reportObj.standardFlag === 'N';
                    let disabled1 = this.reportObj.testType === 'TYPETEST' && notStandardFlag;
                    let disabled2 = this.reportObj.testType === 'DPA';
                    let len = this.block.tableData.length;
                    let len2 = this.block2.tableData.length;
                    
                    if (this.uploadFiles.length === 0) {
                        // 测试的样品照片
                        this.showTips(this.$t('typeTestProcessSearch.t107')); // 请上传测试的样品照片
                        flag = false;
                        return false;
                    }
                    if ((disabled1 || disabled2) && this.uploadFiles2.length === 0) {
                        this.showTips(this.$t('typeTestProcessSearch.t108')); // 请上传供方报告附件
                        flag = false;
                        return false;
                    }

                    if (notStandardFlag && len === 0) {
                        flag = false;
                        this.$Message.warning(this.$t('typeTestProcessSearch.t109')); // 计量检验至少新增一行
                        return false;
                    }
                    if (notStandardFlag && len2 === 0) {
                        flag = false;
                        this.$Message.warning(this.$t('typeTestProcessSearch.t110')); // 计数检验至少新增一行
                        return false;
                    }
                    if (notStandardFlag) {
                        // 非我司标准，表格新增行数据项必填
                        try {
                            let needKeys = []; // 计量检验新增行的数据项
                            let needKeys2 = []; // 计数检验新增行的数据项
                            let handKeys = [];
                            let handKeys2 = [];
                            let hasNull = false;
                            let hasNull2 = false;
                            this.block.tableColumns.columns.forEach(item => {
                                // 排除计量或计数都不需要校验的字段
                                if (item.key !== 'num' && item.key !== 'remark' && item.key !== 'opt') {
                                    needKeys.push(item.key);
                                }
                            });
                            console.log('needKeys::', needKeys);
                            for (let i = 0; i < len; i++) {
                                let obj = this.block.tableData[i];
                                // sourceType: "GSC"代表GSC新增数据，sourceType: "QMS"代表QMS数据
                                if (obj.id && !obj.sourceType) {
                                    if (obj.examinedStatus === 'OK' || obj.examinedStatus === 'NA') {
                                        // 检验结果NA排除（缺陷描述、项目不良数、项目附注、测量值、测试后实物图片）
                                        needKeys.forEach(each => {
                                            if (obj.examinedStatus === 'NA') {
                                                if (each !== 'ngInfo' && each !== 'ngQty' && each !== 'fileId' && each.indexOf('testValue') === -1) {
                                                    handKeys.push(each);
                                                }
                                            } else { // OK
                                                if (each !== 'ngInfo' && each !== 'ngQty' && each !== 'fileId') {
                                                    handKeys.push(each);
                                                }
                                            }
                                        });
                                    } else { // NG
                                        handKeys = JSON.parse(JSON.stringify(needKeys));
                                    }
                                    console.log('handKeys::', handKeys);
                                    handKeys.forEach(key => {
                                        if (!obj[key] && obj[key] !== 0) {
                                            console.log('obj_key:', key);
                                            // 计量检验新增行的数据项不能为空，请完成填写
                                            this.showTips(this.$t('typeTestProcessSearch.t111'));
                                            hasNull = true;
                                        }
                                    });
                                }
                            }
                            if (hasNull) {
                                this.showTips(this.$t('typeTestProcessSearch.t111')); // 计量检验新增行的数据项不能为空，请完成填写
                                flag = false;
                                return false;
                            }
                            this.block2.tableColumns.columns.forEach(item2 => {
                                if (item2.key !== 'num' && item2.key !== 'remark' && item2.key !== 'opt') {
                                    needKeys2.push(item2.key);
                                }
                            });
                            console.log('needKeys2::', needKeys2);
                            for (let i = 0; i < len2; i++) {
                                let obj2 = this.block2.tableData[i];
                                // sourceType: "GSC"代表GSC新增数据，sourceType: "QMS"代表QMS数据
                                if (obj2.id && !obj2.sourceType) {
                                    if (obj2.examinedStatus === 'OK' || obj2.examinedStatus === 'NA') {
                                        // 检验结果NA排除（缺陷描述、项目不良数、项目附注、测试后实物图片）
                                        needKeys2.forEach(each2 => {
                                            if (obj2.examinedStatus === 'NA') {
                                                if (each2 !== 'ngInfo' && each2 !== 'ngQty' && each2 !== 'fileId') {
                                                    handKeys2.push(each2);
                                                }
                                            } else { // OK
                                                if (each2 !== 'ngInfo' && each2 !== 'ngQty') {
                                                    handKeys2.push(each2);
                                                }
                                            }
                                        });
                                    } else { // NG
                                        handKeys2 = JSON.parse(JSON.stringify(needKeys2));
                                    }
                                    console.log('handKeys2::', handKeys2);
                                    handKeys2.forEach(key => {
                                        if (!obj2[key] && obj2[key] !== 0) {
                                            console.log('obj2_key:', key);
                                            this.showTips(this.$t('typeTestProcessSearch.t112')); // 计量检验新增行的数据项不能为空，请完成填写
                                            hasNull2 = true;
                                        }
                                    });
                                }
                            }
                            if (hasNull2) {
                                // 计数检验新增行的数据项不能为空，请完成填写
                                this.showTips(this.$t('typeTestProcessSearch.t112'));
                                flag = false;
                                return false;
                            }
                        } catch (error) {
                            console.log('error:', error);
                        }
                    } else {
                        // 是我司标准，表格行数据带 * 标识的数据项必填
                        let hasNull = false;
                        this.block.tableData.map((item) => {
                            let sampleQty = item.sampleQty >= 5 ? 5 : item.sampleQty;
                            console.log('item.sampleQty::', item.sampleQty);
                            console.log('item.sampleMeteringCount::', item.sampleMeteringCount);
                            if (item.examinedStatus !== 'NA') {
                                item.sampleMeteringCount.map((item2, key) => {
                                    if (!item2 && key <= sampleQty - 1) {
                                        hasNull = true;
                                    }
                                });
                            }
                        });
                        if (hasNull) {
                            this.showTips(this.$t('typeTestProcessSearch.t113')); // 测量值不允许为空，请完成填写
                            flag = false;
                            return false;
                        }
                        for (let i = 0; i < len; i++) {
                            let obj = this.block.tableData[i];
                            if (obj.examinedStatus !== 'NA') {
                                // 检验结果
                                if (!obj.examinedStatus) {
                                    // 计量检验【检验结果】不能为空
                                    this.showTips(this.$t('typeTestProcessSearch.t114'));
                                    flag = false;
                                    return false;
                                }
                                // 缺陷描述（检验结果不合格的时候，需要必填）
                                if (!obj.ngInfo && obj.examinedStatus === 'NG') {
                                    // 计量检验【检验结果】不合格，【缺陷描述】不能为空
                                    this.showTips(this.$t('typeTestProcessSearch.t115'));
                                    flag = false;
                                    return false;
                                }
                                // 项目不良数（检验结果不合格的时候，需要必填）
                                if (!obj.ngQty && obj.examinedStatus === 'NG') {
                                    // 计量检验【检验结果】不合格，【项目不良数】不能为空
                                    this.showTips(this.$t('typeTestProcessSearch.t116'));
                                    flag = false;
                                    return false;
                                }
                                // 测试后实物图片
                                if (!obj.fileId) {
                                    // 计量检验【测试后实物图片】不能为空
                                    this.showTips(this.$t('typeTestProcessSearch.t117'));
                                    flag = false;
                                    return false;
                                }
                            }
                        }
                        for (let j = 0; j < len2; j++) {
                            let obj2 = this.block2.tableData[j];
                            console.log('obj2::', obj2);
                            if (obj2.examinedStatus !== 'NA') {
                                // 检验结果
                                if (!obj2.examinedStatus) {
                                    // 计数检验【检验结果】不能为空
                                    this.showTips(this.$t('typeTestProcessSearch.t118'));
                                    flag = false;
                                    return false;
                                }
                                // 缺陷描述（检验结果不合格的时候，需要必填）
                                if (!obj2.ngInfo && obj2.examinedStatus === 'NG') {
                                    // 计数检验【检验结果】不合格，【缺陷描述】不能为空
                                    this.showTips(this.$t('typeTestProcessSearch.t119'));
                                    flag = false;
                                    return false;
                                }
                                // 项目不良数（检验结果不合格的时候，需要必填）
                                if (!obj2.ngQty && obj2.examinedStatus === 'NG') {
                                    // 计数检验【检验结果】不合格，【项目不良数】不能为空
                                    this.showTips(this.$t('typeTestProcessSearch.t120'));
                                    flag = false;
                                    return false;
                                }
                                // 测试后实物图片
                                if (!obj2.fileId) {
                                    // 计数检验【测试后实物图片】不能为空
                                    this.showTips(this.$t('typeTestProcessSearch.t121'));
                                    flag = false;
                                    return false;
                                }
                            }
                        }
                    }
                } else {
                    flag = false;
                }
            });
            return flag;
        },
        // 提交
        reportSubmit (operateType, hasTips = true) {
            if (operateType === 'SUBMIT') {
                if (!this.validRow()) {
                    return false;
                }
            }
            let gscTypeTestFileInfoList = [];
            let gscTypeTestDetailInfoList = [];
            if (this.uploadFiles.length !== 0) {
                // 测试的样品照片
                this.uploadFiles.forEach(item => {
                    let obj = {
                        fileId: item.annexId,
                        fileType: 'TEST',
                        fileName: item.annexName
                    }
                    gscTypeTestFileInfoList.push(obj);
                });
            }
            if (this.uploadFiles2.length !== 0) {
                // 供方报告附件
                this.uploadFiles2.forEach(item2 => {
                    let obj2 = {
                        fileId: item2.annexId2,
                        fileType: 'REPORT',
                        fileName: item2.annexName2
                    }
                    gscTypeTestFileInfoList.push(obj2);
                });
            }
            gscTypeTestDetailInfoList = this.block.tableData.concat(this.block2.tableData);
            console.log('reportSubmit__gscTypeTestDetailInfoList::', gscTypeTestDetailInfoList);
            let language = this.$i18n.locale;
            let params = {
                ...this.reportObj,
                operateType: operateType === 'SUBMIT' ? 'SUBMIT' : 'TS', // 提交SUBMIT（必填） 暂存TS（非）
                gscTypeTestDetailInfoList: gscTypeTestDetailInfoList,
                gscTypeTestFileInfoList: gscTypeTestFileInfoList,
                language: language,
                mdmCode: this.mdmCode
            };
            this.loading = true;
            axios.post('/gscint/gscTypeTestInfo/submitTestType', params)
            .then((res) => {
                this.loading = false;
                if (res.data.data.code === '-1') {
                    this.showTips(res.data.data.msg, 'loading');
                } else {
                    if (operateType === 'SUBMIT') {
                        this.$Modal.success({
                            content: this.$t('HSInspectManageMat.t43') // 提交成功
                        });
                        setTimeout(() => {
                            this.goBack();
                        }, 0);
                    } else {
                        if (hasTips) {
                            this.$Modal.success({
                                content: this.$t('保存成功')
                            });
                        }
                        this.queryDetailInfo();
                    }
                }
            })
            .catch(() => {
                this.showTips(null, 'loading');
            });
        },
        showTECHNICAL_REQUIREMENT(technicalRequirement) {
            // 弹窗方式
            this.htmlTECHNICAL_REQUIREMENT = technicalRequirement;
            this.modalTechnicalRequirement = true;
            // this.$Modal.info({
            //     content: technicalRequirement
            // });
        },
        modalTechnicalRequirement_ok() {
        },
        modalTechnicalRequirement_cancel() {
        },
        goBack () {
            this.$router.push({ name: 'typeTestProcessSearch' });
        },
        /** 测试的样品照片附件 */
        removeFile(file, fileList) {
            console.log('removeFile:', file, fileList);
        },
        downloadFile(docId) {
            window.open(this.downloadStandardsItemFileUrl + docId);
        },
        deleteFile(annexId) {
            if (!annexId) {
                return false;
            }
            axios.post('/qms2gsc/file/delete' + '?id=' + annexId + '&deletefile=Y', {}).then(res => {
                let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
                let result = JSON.parse(jsonStr);
                var IsSucess = result.IsSucess;
                if (IsSucess === true) {
                    this.uploadFiles.forEach((item, index, arr) => {
                        if (item.annexId === annexId) {
                            arr.splice(index, 1);
                        }
                    });
                    this.$Message.success(this.$t('typeTestProcessSearch.t129')); // 删除成功
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('typeTestProcessSearch.t104') // 删除失败
                    });
                }
            }).catch(() => {
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        beforeUpload(file) {
            console.log('beforeUpload::', file);
            if (file.size > 10485760) {
                this.$Message.warning({
                    title: this.$t('common.warn'),
                    content: this.$t('typeTestProcessSearch.t58') // 文件大小不能超过10M！
                });
                return false;
            }
        },
        uploadProgress(event, file, fileList) {
            this.uploadLoading = true;
        },
        uploadSuccess(response, file, fileList) {
            console.log('uploadSuccess::', response, file, fileList);
            let jsonStr = response.substring(1).substring(0, response.length - 3);
            let result = JSON.parse(jsonStr);
            if (result.IsSucess) {
                this.uploadFiles = [];
                this.uploadFiles.push({
                    annexName: file.name,
                    annexId: result.MainResultData,
                });
                this.uploadLoading = false;
                this.$Message.success(this.$t('上传成功')); // 上传成功
            } else {
                this.uploadLoading = false;
                this.showTips();
            }
        },
        fileUpload(file) {
            console.log('``````fileUpload``````::', file);
        },
        failUpload() {
            this.showTips(this.$t('HSInspectManageMat.t79')); // 附件上传失败，请重新上传！
            this.uploadLoading = false;
            this.$refs.uploadFileRef.clearFiles();
        },
        onFormatError() {
            this.uploadLoading = false;
            this.$Modal.error({
                content: this.$t('typeTestProcessSearch.t122').replace('_', this.fileTypeList.join()) // `图片附件只支持${this.fileTypeList.join()}格式` // 图片附件只支持_格式
            });
        },
        /** 测试的样品照片附件end */

        /** 供方报告附件 */
        removeFile2(file, fileList) {
            console.log('removeFile2:', file, fileList);
        },
        downloadFile2(docId) {
            window.open(this.downloadStandardsItemFileUrl + docId);
        },
        deleteFile2(annexId2) {
            if (!annexId2) {
                return false;
            }
            axios.post('/qms2gsc/file/delete' + '?id=' + annexId2 + '&deletefile=Y', {}).then(res => {
                let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
                let result = JSON.parse(jsonStr);
                var IsSucess = result.IsSucess;
                if (IsSucess === true) {
                    this.uploadFiles2.forEach((item, index, arr) => {
                        if (item.annexId2 === annexId2) {
                            arr.splice(index, 1);
                        }
                    });
                    this.$Message.success(this.$t('typeTestProcessSearch.t129')); // 删除成功
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('typeTestProcessSearch.t104') // 删除失败
                    });
                }
            }).catch(() => {
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        beforeUpload2(file) {
            console.log('beforeUpload2::', file);
            if (file.size > 10485760) {
                this.$Message.warning({
                    title: this.$t('common.warn'),
                    content: this.$t('typeTestProcessSearch.t58') // 文件大小不能超过10M！
                });
                return false;
            }
        },
        uploadProgress2(event, file, fileList) {
            this.uploadLoading2 = true;
        },
        uploadSuccess2(response, file, fileList) {
            console.log('uploadSuccess2::', response, file, fileList);
            let jsonStr = response.substring(1).substring(0, response.length - 3);
            let result = JSON.parse(jsonStr);
            if (result.IsSucess) {
                this.uploadFiles2 = [];
                this.uploadFiles2.push({
                    annexName2: file.name,
                    annexId2: result.MainResultData,
                });
                this.uploadLoading2 = false;
                this.$Message.success(this.$t('上传成功')); // 上传成功
            } else {
                this.uploadLoading2 = false;
                this.showTips();
            }
        },
        fileUpload2(file) {
            console.log('``````fileUpload2``````::', file);
        },
        failUpload2() {
            this.showTips(this.$t('HSInspectManageMat.t79')); // 附件上传失败，请重新上传
            this.uploadLoading2 = false;
            this.$refs.uploadFileRef2.clearFiles();
        },
        onFormatError2() {
            this.uploadLoading2 = false;
            this.$Modal.error({
                content: this.$t('typeTestProcessSearch.t102').replace('_', this.fileTypeList2.join()) // `附件只支持${this.fileTypeList2.join()}格式` // 附件只支持_格式
            });
        },
        /** DPA报告模板下载（使用文档中心） */
        downloadDPATemplateFile() {
            window.open(`/gscint/supplierfile/downloadFile?docId=${this.isPro() ? '181d6af605b09f91a5936d9457b8daef' : '181d6a95e84c36ee418298a4d8cac2ee'}`);
        },
        /** 供方报告附件end */
        downloadUploadListFile(fileId) {
            window.open(this.downloadStandardsItemFileUrl + fileId);
        },
        format (file) {
            const format = file.name.split('.').pop().toLocaleLowerCase() || '';
            let type = 'document';
            if (['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'].indexOf(format) > -1) {
                type = 'image';
            }
            if (['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'].indexOf(format) > -1) {
                type = 'ios-film';
            }
            if (['mp3', 'wav', 'wma', 'ogg', 'aac', 'flac'].indexOf(format) > -1) {
                type = 'ios-musical-notes';
            }
            if (['doc', 'txt', 'docx', 'pages', 'epub', 'pdf'].indexOf(format) > -1) {
                type = 'document-text';
            }
            if (['numbers', 'csv', 'xls', 'xlsx'].indexOf(format) > -1) {
                type = 'stats-bars';
            }
            if (['keynote', 'ppt', 'pptx'].indexOf(format) > -1) {
                type = 'ios-videocam';
            }
            return type;
        },
        /** 检验结果 */
        checkedResultChange(paramsRow, paramsIndex, val, type) {
            let arr = paramsRow.sampleMeteringCount;
            console.log('paramsRow.sampleMeteringCount::', paramsRow.sampleMeteringCount);
            if (!paramsRow.sampleMeteringCount && type === '1') {
                // 测量值尚未输入sampleMeteringCount=undefined
                this.sampleMeteringCount(paramsRow, paramsIndex);
                arr = paramsRow.sampleMeteringCount;
            }
            console.log('arr::', arr);
            if (val === 'NA') {
                if (type === '1') {
                    let newArray = [];
                    arr.forEach((item, index) => {
                        newArray.push('');
                        paramsRow[`testValue${index+1}`] = '';
                    });
                    paramsRow.sampleMeteringCount = newArray;
                    paramsRow.ngInfo = '';
                    paramsRow.ngQty = '';
                    paramsRow.fileName = '';
                    paramsRow.fileId = '';
                    console.log('检验结果NA__paramsRow::', paramsRow);
                    this.block.tableData[paramsIndex] = paramsRow;
                }
                if (type === '2') {
                    paramsRow.ngInfo = '';
                    paramsRow.ngQty = '';
                    paramsRow.fileName = '';
                    paramsRow.fileId = '';
                    this[`block${type}`].tableData[paramsIndex] = paramsRow;
                }
            } else if (val === 'OK') {
                if (type === '1') {
                    console.log('paramsRow.ngQty:', paramsRow.ngQty);
                    if (paramsRow.ngQty > 0 || !paramsRow.ngQty && paramsRow.ngQty !== 0) {
                        // 不良数大于0时检验结果切换OK清空测量值
                        let newArray = [];
                        arr.forEach((item, index) => {
                            newArray.push('');
                            paramsRow[`testValue${index+1}`] = '';
                        });
                        paramsRow.sampleMeteringCount = newArray;
                        paramsRow.ngQty = '';
                    }
                    paramsRow.ngInfo = '';
                    this.block.tableData[paramsIndex] = paramsRow;
                }
                if (type === '2') {
                    paramsRow.ngInfo = '';
                    paramsRow.ngQty = '';
                    this[`block${type}`].tableData[paramsIndex] = paramsRow;
                }
            } else if (val === 'NG') {
                if (type === '1') {
                    console.log('paramsRow.ngQty:', paramsRow.ngQty);
                    if (paramsRow.ngQty === 0) {
                        // 不良数大于0时检验结果切换OK清空测量值
                        let newArray = [];
                        arr.forEach((item, index) => {
                            newArray.push('');
                            paramsRow[`testValue${index+1}`] = '';
                        });
                        paramsRow.sampleMeteringCount = newArray;
                        paramsRow.ngQty = '';
                    }
                    this.block.tableData[paramsIndex] = paramsRow;
                }
            }
            this.changeReportObjCHECKED_RESULT();
        },
        /** 综合判断结果 */
        changeReportObjCHECKED_RESULT() {
            let len1 = this.block.tableData.length;
            for (let i1 = 0; i1 < len1; i1++) {
                if (this.block.tableData[i1].examinedStatus && this.block.tableData[i1].examinedStatus === this.checkResultList[1].value) {
                    this.$set(this.reportObj, 'mainJudge', 'UNQUALIFIED');
                    this.$set(this.reportObj, 'mainJudgeName', this.$t('typeTestProcessSearch.t66')); // 不合格
                    return;
                }
            }
            let len2 = this.block2.tableData.length;
            for (let i2 = 0; i2 < len2; i2++) {
                if (this.block2.tableData[i2].examinedStatus && this.block2.tableData[i2].examinedStatus === this.checkResultList[1].value) {
                    this.$set(this.reportObj, 'mainJudge', 'UNQUALIFIED');
                    this.$set(this.reportObj, 'mainJudgeName', this.$t('typeTestProcessSearch.t66')); // 不合格
                    return;
                }
            }
            this.$set(this.reportObj, 'mainJudge', 'QUALIFIED');
            this.$set(this.reportObj, 'mainJudgeName', this.$t('typeTestProcessSearch.t65')); // 合格
        },
        /** 测量值集合 */
        sampleMeteringCount(paramsRow, paramsIndex) {
            let newArray = [];
            for (const k in paramsRow) {
                if (Object.hasOwnProperty.call(paramsRow, k)) {
                    if (k.indexOf('testValue') > -1) {
                        newArray.push(paramsRow[k]);
                    }
                }
            }
            paramsRow.sampleMeteringCount = newArray;
            this.block.tableData[paramsIndex] = paramsRow;
            // 计算项目不良数
            // let remNum = 0;
            // this.block.tableData[paramsIndex].sampleMeteringCount.map(item => {
            //     let val = this.sampleMeteringOnChange2(paramsRow, paramsIndex, item, false);
            //     if (!val) {
            //         remNum++;
            //     }
            // });
            // paramsRow.ngQty = remNum;
            // this.block.tableData[paramsIndex] = paramsRow;
        },
        // 对比数据结果 （根据校验规则来指定比较方案）
        returnCompare (PROPERTY, inputVal, minOrMax) {
            let flag = true;
            inputVal = parseFloat(inputVal);
            minOrMax = parseFloat(minOrMax);
            if (minOrMax || minOrMax === 0) {
                if (PROPERTY === '＞') {
                    flag = inputVal > minOrMax;
                } else if (PROPERTY === '≥') {
                    flag = inputVal >= minOrMax;
                } else if (PROPERTY === '＜') {
                    flag = inputVal < minOrMax;
                } else if (PROPERTY === '≤') {
                    flag = inputVal <= minOrMax;
                }
            } else {
                flag = true;
            }
            return flag;
        },
        // 测量值修改
        sampleMeteringOnChange(paramsRow, paramsIndex, val, isShowTips) {
            let isError = false;
            let iptVal = parseFloat(val);
            let minVal = parseFloat(paramsRow.itemsPropertyFloor);
            let maxVal = parseFloat(paramsRow.itemsPropertyCeiling);
            let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
            if (!isNaN(val) && numberRule.test(val) && val) {
                if (!this.returnCompare('≥', iptVal, minVal) || !this.returnCompare('≤', iptVal, maxVal)) {
                // if (!this.returnCompare(paramsRow.ITEMS_PROPERTY_FLOOR_TERMS, iptVal, minVal) || !this.returnCompare(paramsRow.ITEMS_PROPERTY_CEILING_TERMS, iptVal, maxVal)) {
                    if (isShowTips) {
                        this.showTips(this.$t('typeTestProcessSearch.t123')); // 检验结果判定: 不合格
                    }
                    isError = true;
                }
            } else {
                if (isShowTips) {
                    this.showTips(this.$t('typeTestProcessSearch.t124')); // 测量值存在非法数字，请重新检查
                }
                isError = true;
            }
            if (isError) {
                if (isShowTips) {
                    this.block.tableData[paramsIndex].examinedStatus = 'NG';
                }
            } else {
                if (isShowTips) {
                    let allOk = true;
                    let isTrue = false;
                    console.log('allOk__.sampleMeteringCount::', this.block.tableData[paramsIndex].sampleMeteringCount);
                    this.block.tableData[paramsIndex].sampleMeteringCount.forEach((item, index) => {
                        if (item && item !== 0) {
                            let val = !this.sampleMeteringOnChange(paramsRow, paramsIndex, item, false);
                            if (!val) {
                                allOk = false;
                            }
                            if ((this.block.tableData[paramsIndex].sampleMeteringCount[0] === item) && index > 0) {
                                // 校验个数大于>=2从第二项开始比较
                                isTrue = true;
                            }
                        }
                    });
                    if (allOk) {
                        this.block.tableData[paramsIndex].examinedStatus = 'OK';
                    }
                    if (isTrue) {
                    // if (this.block.tableData[paramsIndex].sampleQty >= 2 && isTrue) {
                        // 填写数据一样，涉嫌数据作假，请重新确认填写数据情况
                        this.$Message.error({
                            duration: 2.5,
                            content: this.$t('typeTestProcessSearch.t125')
                        });
                    }
                }
            }
            return isError;
        },
        // sampleMeteringOnChange2(paramsRow, paramsIndex, val, isShowTips) {
        //     let iptVal = parseFloat(val);
        //     let minVal = parseFloat(paramsRow.itemsPropertyFloor);
        //     let maxVal = parseFloat(paramsRow.itemsPropertyCeiling);
        //     let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
        //     let tag = true;
        //     if (!isNaN(val) && numberRule.test(val) && val) {
        //         if (!this.returnCompare('≥', iptVal, minVal) || !this.returnCompare('≤', iptVal, maxVal)) {
        //             tag = false;
        //         }
        //     }
        //     return tag;
        // },
        // 项目不良数修改
        ngqtyOnChange (val, paramsIndex) {
            if (!isNaN(val) && val >= 0) {
                // if (val > 0) {
                //     this.block2.tableData[paramsIndex].examinedStatus = 'NG';
                //     this.$Modal.error({
                //         title: this.$t('common.warn'),
                //         content: this.$t('检验结果判定: 不合格.')
                //     });
                // }
                this.block2.tableData[paramsIndex].ngQty = parseFloat(val);
            } else {
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('typeTestProcessSearch.t87') // 项目不良数必须大于或等于0
                });
                // this.block2.tableData[paramsIndex].examinedStatus = '';
                this.block2.tableData[paramsIndex].ngQty = '';
            }
        },
        setSomeColumns(num) {
            // 生成测量值个数
            let needColsArr = [];
            let needColsTitle = [];
            let len = num || this.inputArray.length;
            for (let i = 0; i < len; i++) {
                let idx = i + 1;
                needColsTitle.push(`${this.$t('typeTestProcessSearch.t126')}${idx}`); // 测量值
                needColsArr.push({
                    renderHeader: (h, params) => {
                        let spanX = this.createSpanX(h);
                        let span = this.createSpan(h, params);
                        return h("div", {}, [spanX, span]);
                    },
                    title: `${this.$t('typeTestProcessSearch.t126')}${idx}`, // 测量值
                    key: `testValue${idx}`,
                    tooltip: true,
                    minWidth: 100,
                    render: (h, params) => {
                        // 是我司标准且qms返回，或者非我司标准gsc新增
                        let disabled = !((this.reportObj.standardFlag === 'Y' && params.row.sourceType === 'QMS') || (this.reportObj.standardFlag === 'N' && !params.row.sourceType));
                        let isNA = params.row.examinedStatus === 'NA';
                        let ipt = h('Input', {
                            props: {
                                value: params.row[`testValue${idx}`],
                                size: 'small',
                                type: 'text',
                                disabled: disabled || isNA || this.btnDisabled,
                            },
                            on: {
                                'on-blur': (event) => {
                                    let iptVal = event.target.value;
                                    let numberRule = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
                                    if (!params.row.itemsPropertyCeiling && !params.row.itemsPropertyFloor) {
                                        this.showTips(this.$t('typeTestProcessSearch.t127')); // 请先输入最大或最小值
                                        event.target.value = '';
                                        params.row[`testValue${idx}`] = '';
                                        return false;
                                    }
                                    if (isNaN(iptVal) || !numberRule.test(iptVal)) {
                                        this.showTips(this.$t('typeTestProcessSearch.t128')); // 测量值必须为有效数值
                                        event.target.value = '';
                                        params.row[`testValue${idx}`] = '';
                                        return false;
                                    }
                                    params.row[`testValue${idx}`] = parseFloat(iptVal);
                                    this.block.tableData[params.index] = params.row;
                                    console.log(`测量值${idx}_params.row::`, params.row);
                                    this.sampleMeteringCount(params.row, params.index);
                                    this.sampleMeteringOnChange(params.row, params.index, iptVal, true);
                                }
                            }
                        });
                        return ipt;
                    }
                });
            }
            this.block.tableColumns.columns = this.block.tableColumns.columns.filter((item) => !needColsTitle.includes(item.title));
            this.block.tableColumns.columns.forEach((item, index) => {
                if (item.key === 'itemsPropertyBenchmark') { // 基准值
                    for (let y = len - 1; y >= 0; y--) {
                        this.block.tableColumns.columns.splice(index + 1, 0, needColsArr[y]);
                    }
                }
            });
        },
        setData(data) {
            console.log('data::', data);
            let mFileList = [];
            let fileList1 = [];
            let fileList2 = [];
            if (data.commonStandardId) {
                mFileList.push({name: data.commonStandardName, fileId: data.commonStandardId});
            }
            if (data.specialStandardId) {
                mFileList.push({name: data.specialStandardName, fileId: data.specialStandardId});
            }
            if (data.gscTypeTestFileInfoList && data.gscTypeTestFileInfoList.length > 0) {
                data.gscTypeTestFileInfoList.forEach(each => {
                    if (each.fileType === 'TEST' && each.fileId) {
                        fileList1.push({
                            annexId: each.fileId,
                            annexName: each.fileName
                        });
                    }
                    if (each.fileType === 'REPORT' && each.fileId) {
                        fileList2.push({
                            annexId2: each.fileId,
                            annexName2: each.fileName
                        });
                    }
                });
                this.uploadFiles = fileList1;
                this.uploadFiles2 = fileList2;
            }
            this.reportObj = JSON.parse(JSON.stringify(data));
            // 合格  不合格
            this.reportObj.mainJudgeName = this.reportObj.mainJudge === 'QUALIFIED' ? this.$t('typeTestProcessSearch.t65') : this.$t('typeTestProcessSearch.t66');
            // 状态WAITING可提交，否则不可提交 :disabled="reportObj.reportStatus !== 'WAITING'"
            this.btnDisabled = this.reportObj.reportStatus !== 'WAITING';
            
            this.mideaPICdownloadList = mFileList;
            // 校验类型(COUNT计数 METER计量)
            this.block.tableData = data.gscTypeTestDetailInfoList.filter((item) => item.testType === 'METER');
            this.block2.tableData = data.gscTypeTestDetailInfoList.filter((item) => item.testType !== 'METER');
            // 计量检验行明细-样本数SAMPLE_QTY
            this.block.tableData.map((item) => {
                this.inputArrayList.push(item.sampleQty > 5 ? 5 : item.sampleQty);
            });
            if (this.inputArrayList.length > 0) {
                try {
                    this.inputArray = Array(Math.max(...this.inputArrayList));
                } catch (error) {
                    console.log('error', error);
                }
            }
            this.block.tableData.map((item, index) => {
                let newArray = [];
                for (let i = 0; i < this.inputArrayList[index]; i++) {
                    newArray.push(item['testValue' + (i+1)] || '');
                }
                this.block.tableData[index].sampleMeteringCount = newArray;
            });
            if (this.inputArray.length > 0) {
                // debugger;
                this.setSomeColumns();
            }
        },
        /** 获取详情 */
        queryDetailInfo() {
            let language = this.$i18n.locale.includes('US') ? 'US' : this.$i18n.locale;
            let params = {
                testTypeReqId: this.testTypeReqId,
                language: language,
                isSaveLog: this.isPro() ? 'N' : 'Y', // 生产环境传N，测试环境传Y
                mdmCode: this.mdmCode,
                language: language
            };
            this.loading = true;
            axios.get('/gscint/gscTypeTestInfo/queryDetailInfo', {params})
            .then(res => {
                this.loading = false;
                if (res.data.success === true) {
                    let data = res.data.data;
                    // qms附件上传
                    this.uploadFileUrl1 = this.uploadFileUrl + `?busid=${data.id}&ref_data_type=BEFORE_TEST`;
                    this.uploadFileUrl2 = this.uploadFileUrl + `?busid=${data.id}&ref_data_type=SUPPLIER_REPORT`;
                    // debugger
                    this.setData(data);
                } else {
                    // this.$Modal.error({
                    //     title: this.$t('common.warn'),
                    //     content: res.data.msg
                    // });
                }
            })
            .catch(err => {
                this.loading = false;
                // this.$Modal.error({
                //     title: this.$t('common.warn'),
                //     content: this.$t('common.error1'),
                //     error: err.stack.toString()
                // });
            });
        },
        queryVendorAndMdm() {
            axios.post('/gscint/vendor/queryVendorAndMdm', {
                vendorCode: this.vendorCode
            }).then((res) => {
                this.mdmCode = res.data.data.datas.mdmCode;
            });
        },
    },
    mounted() {
        let routeParams = this.$route.query ? this.$route.query : {};
        this.testTypeReqId = routeParams.id ? routeParams.id : '';
        this.queryVendorAndMdm();
        this.queryDetailInfo();
    },
    activated() {
        let routeParams = this.$route.query ? this.$route.query : {};
        this.testTypeReqId = routeParams.id ? routeParams.id : '';
        this.queryVendorAndMdm();
        this.queryDetailInfo();
    }
};
</script>

<style lang='less' scoped>
.title-bar {
    background-color: #F2F2F2;
    border: 1px solid #dddee1;
    padding: 10px 20px;
    button {
        float: right;
    }
    span {
        border-left: 5px solid #3AA2EB;
        padding: 0 7px;
        font-size: 15px;
        font-weight: 400;
        height: 32px;
        line-height: 32px;
    }
}
.container {
    padding: 10px 20px;
    .form-wrap {
        background:#FFF;
        padding:10px 20px 10px 0;
    }
}
/deep/ .m-form .m-form-item-label {
    padding-right: 5px;
}
/deep/ .report-input .m-input{
    padding: 4px;
}
.table-wrap {
    /deep/ .m-card-body {
        padding: 0px;
    }
}
.btn-dpa {
    padding: 4px 0px 4px 20px;
    display:inline-block;
}
.mg-t-20 {
    margin-top: 20px;
}
.mg-r-10 {
    margin-right: 10px;
}
.mg-l-30 {
    margin-left: 30px;
}
</style>
